var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classes,style:(_vm.styles)},[(_vm.src)?_c('img',{attrs:{"src":_vm.src},on:{"error":_vm.handleError}}):(_vm.icon || _vm.customIcon)?_c('Icon',{attrs:{"type":_vm.icon,"custom":_vm.customIcon}}):_c('span',{ref:"children",class:[_vm.prefixCls + '-string'],style:(_vm.childrenStyle)},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }